import React, { useState, useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CONFIG from "../src/config"; // Import the config file
import "./Uploadcvdesign.css";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

function CVUploadForm() {
  const location = useLocation(); // Get the current location (path)

  const meta = metaConfig.uploadcv;

  const [isOtherSelected, setIsOtherSelected] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",

    phone: "",
    jobTitle: "",
    otherJobTitle: "",

    experience: "",
    coverLetter: "",
    resume: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const fileInputRef = useRef(null); // Reference for file input field

  //////validate form
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};
    if (!formData.firstName.trim() || formData.firstName.length < 2) {
      newErrors.firstName = "First Name is required (min 2 characters).";
    }

    // Last Name validation
    if (!formData.lastName.trim() || formData.lastName.length < 1) {
      newErrors.lastName = "Last Name is required (min 1 characters).";
    }

    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const allowedEmailPattern =
      /^[\w.-]+@(gmail\.com|yahoo\.com|outlook\.com|rediffmail\.com|hotmail\.com|icloud\.com|protonmail\.com|aol\.com|cogniitec\.com)$/;

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!emailPattern.test(formData.email)) {
      newErrors.email = "Valid Email is required.";
    } else if (!allowedEmailPattern.test(formData.email)) {
      newErrors.email =
        "Please enter valid email format (e.g., user@gmail.com)";
    }

    const phonePattern = /^[6789]\d{9}$/;
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone Number is required.";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Phone number must be exactly 10 digits.";
    } else if (!phonePattern.test(formData.phone)) {
      newErrors.phone =
        "Contact must be 10 digits and start with 6, 7, 8, or 9.";
    }

    if (!formData.jobTitle.trim()) {
      newErrors.jobTitle = "Job Title is required.";
    }

    // Experience validation (must be a valid number and not negative)
    if (!formData.experience.trim()) {
      newErrors.experience = "Experience is required";
    }

    if (!formData.resume) {
      newErrors.resume = "Please upload a CV (PDF, DOC, DOCX).";
    } else {
      const allowedFormats = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!allowedFormats.includes(formData.resume.type)) {
        newErrors.resume =
          "Invalid file format. Only PDF, DOC, or DOCX allowed.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((prevData) => {
      let newValue = value;

      if (name === "email") {
        newValue = value.toLowerCase(); // Convert email to lowercase
      } else if (files && files.length > 0) {
        newValue = files[0]; // Handle file upload
      } else if (name === "phone") {
        if (!/^\d{0,10}$/.test(value)) return prevData; // Allow only 10-digit numbers
      }

      return {
        ...prevData,
        [name]: newValue,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formDataToSend = new FormData();
    formDataToSend.append("firstName", formData.firstName);
    formDataToSend.append("lastName", formData.lastName);
    formDataToSend.append("email", formData.email);

    formDataToSend.append("phone", formData.phone);
    formDataToSend.append(
      "jobTitle",
      formData.jobTitle || formData.otherJobTitle
    );
    formDataToSend.append("experience", formData.experience);
    formDataToSend.append("coverLetter", formData.coverLetter);
    formDataToSend.append("resume", formData.resume);

    setIsSubmitting(true);

    try {
      const response = await axios.post(
        `${CONFIG.BASE_URL}/career/apply`,
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      console.log(response, "response>>");

      if (response.status === 201 || response.status === 200) {
        Swal.fire({
          title: "Job Applied!",
          text: "We appreciate your interest in joining KTIG.",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });

        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          otherJobTitle: "",
          jobTitle: "",
          experience: "",
          coverLetter: "",
          resume: null,
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        toast.error(`Failed to send email: ${response.data.error}`, {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while sending the email.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  return (
    <div className="fileup_wrap ">
      <SEO {...meta} />

      <Header />
      <ToastContainer />
      <div className="group_contact fileupinner" style={styles.formContainer}>
        <div className="cvuploadwrap" style={styles.container}>
          <h2 className="mt-5" style={styles.heading}>
            Upload Your CV
          </h2>
          <form autoComplete="off" onSubmit={handleSubmit} style={styles.form}>
            {/* Form fields */}
            <div className="fieldwrap" style={styles.formGroup}>
              <label style={styles.label}>First Name</label>
              <input
                type="text"
                name="firstName"
                placeholder="Enter your first name"
                // required
                value={formData.firstName}
                onChange={(e) => {
                  let value = e.target.value;

                  // Capitalize each word
                  value = value
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase());

                  handleChange({
                    target: {
                      name: "firstName",
                      value: value,
                    },
                  });
                }}
                onKeyDown={(e) => {
                  // Allow letters, spaces, backspace, and tab
                  if (
                    !/^[a-zA-Z\s]$/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "Tab"
                  ) {
                    e.preventDefault();
                  }
                }}
                style={styles.input}
              />

              {errors.firstName && <p className="error">{errors.firstName}</p>}
            </div>
            <div className="fieldwrap" style={styles.formGroup}>
              <label style={styles.label}>Last Name</label>
              <input
                type="text"
                name="lastName"
                placeholder="Enter your last name"
                value={formData.lastName}
                onChange={(e) => {
                  let value = e.target.value;
                  handleChange({
                    target: {
                      name: "lastName",
                      value: value,
                    },
                  });
                }}
                onKeyDown={(e) => {
                  // Allow uppercase letters, lowercase letters, spaces, backspace, and tab
                  if (
                    !/^[a-zA-Z\s]$/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "Tab"
                  ) {
                    e.preventDefault();
                  }
                }}
                style={styles.input}
              />
              {errors.lastName && <p className="error">{errors.lastName}</p>}
            </div>

            <div className="fieldwrap" style={styles.formGroup}>
              <label style={styles.label}>Email Address</label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                style={styles.input}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
            <div className="fieldwrap " style={styles.formGroup}>
              <div className="contact_input_wrap">
                <label style={styles.label}>Phone Number</label>
                <div className="input-group">
                  <span
                    class="form-select form-control border-1 countryCode"
                    name="countryCode"
                    value="+91"
                  >
                    <option value="+91">IN +91</option>
                  </span>
                  <input
                    className="form-control border-1 "
                    type="tel"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={formData.phone}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (/^\d{0,10}$/.test(value)) {
                        handleChange(e);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (
                        !/^[0-9]$/.test(e.key) &&
                        ![
                          "Backspace",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ].includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    style={styles.input}
                  />
                </div>
              </div>
              {formData.phone.length > 10 && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Phone number must be 10 digits only.
                </span>
              )}

              {errors.phone && <p className="error">{errors.phone}</p>}
            </div>

            <div
              className="fieldwrap firstchildlabel "
              style={styles.formGroup}
            >
              <label style={styles.label}>Job Title</label>
              <select
                className=""
                name="jobTitle"
                value={formData.jobTitle}
                onChange={(e) => {
                  const value = e.target.value;
                  const isOther = value === "Other";

                  setIsOtherSelected(isOther);

                  handleChange({
                    target: {
                      name: "jobTitle",
                      value: isOther
                        ? formData.otherJobTitle || "Other"
                        : value,
                    },
                  });
                }}
                style={styles.input}
              >
                <option value="">Select your job title</option>
                <option value="Frontend Developer">Frontend Developer</option>
                <option value="Backend Developer">Backend Developer</option>
                <option value="Full Stack Developer">
                  Full Stack Developer
                </option>
                <option value="UI/UX Designer">UI/UX Designer</option>
                <option value="Software Engineer">Software Engineer</option>
                <option value="Data Scientist">Data Scientist</option>
                <option value="DevOps Engineer">DevOps Engineer</option>
                <option value="Product Manager">Product Manager</option>
                <option value="Quality Analyst">Quality Analyst</option>
                <option value="Mobile App Developer">
                  Mobile App Developer
                </option>
                <option value="Cloud Engineer">Cloud Engineer</option>
                <option value="System Administrator">
                  System Administrator
                </option>
                <option value="Security Engineer">Security Engineer</option>
                <option value="Business Analyst">Business Analyst</option>
                <option value="Project Manager">Project Manager</option>
                <option value="Data Analyst">Data Analyst</option>
                <option value="Network Engineer">Network Engineer</option>
                <option>Other</option>
              </select>

              {errors.jobTitle && <p className="error">{errors.jobTitle}</p>}
              {errors.otherJobTitle && (
                <p className="error">{errors.otherJobTitle}</p>
              )}
            </div>

            {isOtherSelected && (
              <div
                className="fieldwrap firstchildlabel "
                style={styles.formGroup}
              >
                <div className="other-job-title">
                  <label style={styles.label}>
                    Please specify your job title
                  </label>
                  <input
                    type="text"
                    name="otherJobTitle"
                    placeholder="Enter your job title"
                    value={formData.otherJobTitle || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      handleChange({
                        target: {
                          name: "otherJobTitle",
                          value: value,
                        },
                      });

                      handleChange({
                        target: {
                          name: "jobTitle",
                          value: value,
                        },
                      });
                    }}
                    style={styles.input}
                  />
                </div>
              </div>
            )}

            <div
              className="fieldwrap firstchildlabel "
              style={styles.formGroup}
            >
              <label style={styles.label}>Experience</label>
              <select
                name="experience"
                value={formData.experience}
                onChange={(e) => {
                  handleChange({
                    target: {
                      name: "experience",
                      value: e.target.value,
                    },
                  });
                }}
                className="firstlable form-control border-1"
                style={styles.input}
              >
                <option className="" value="" disabled selected>
                  Select Experience
                </option>

                <option value="Fresher">Fresher</option>
                <option value="1 Yrs">1 Yrs</option>
                <option value="2 Yrs">2 Yrs</option>
                <option value="3 Yrs">3 Yrs</option>
                <option value="4 Yrs">4 Yrs</option>
                <option value="5 Yrs">5 Yrs</option>
                <option value="6 Yrs">6 Yrs</option>
                <option value="7 Yrs">7 Yrs</option>
                <option value="8 Yrs">8 Yrs</option>
                <option value="9 Yrs">9 Yrs</option>
                <option value="10+ Yrs">10+ Yrs</option>
              </select>
              {errors.experience && (
                <p className="error">{errors.experience}</p>
              )}
            </div>

            <div
              className="fieldwrap attachfile_input"
              style={styles.formGroup}
            >
              <label style={styles.label}>Upload CV</label>
              <input
                type="file"
                name="resume"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                ref={fileInputRef}
              />
              {errors.resume && <p className="error">{errors.resume}</p>}
            </div>
            <div className="fieldwrap_msg" style={styles.formGroup}>
              <label style={styles.label}>Cover Letter ( Optinal )</label>
              <textarea
                name="coverLetter"
                placeholder="Write a brief cover letter"
                value={formData.coverLetter}
                autoCapitalize="sentences"
                onChange={(e) => {
                  let value = e.target.value;

                  value = value.replace(/(^\s*\w|[.!?]\s*\w)/g, (char) =>
                    char.toUpperCase()
                  );

                  handleChange({
                    target: {
                      name: "coverLetter",
                      value: value,
                    },
                  });
                }}
                style={styles.textarea}
              />
            </div>
            <div className="filesubmit" style={styles.buttonGroup}>
              <button
                className="btn-grad"
                type="submit"
                style={styles.submitButton}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Processing..." : "Submit"}
              </button>
            </div>
          </form>
        </div>

        {/* Alert Popup */}
        {showAlert && (
          <div style={styles.alertContainer}>
            <div style={styles.alertBox}>
              <p style={styles.alertMessage}>{alertMessage}</p>
              <button onClick={closeAlert} style={styles.closeButton}>
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      <Footer />
      <button
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
        onClick={() => window.scrollTo(0, 0)}
      >
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    // background: "rgba(0, 0, 0, 0.1)",
    paddingTop: "12rem",
  },
  formContainer: {
    padding: " 0 20px 20px",
    borderRadius: "8px",
    // backgroundColor: "rgba(255, 255, 255, 0.9)",
    // boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)",
  },
  heading: {
    textAlign: "center",
    color: "#ffffff",
    fontSize: "24px",
    marginBottom: "20px",
  },
  header: {
    backgroundColor: "#4CAF50",
    padding: "10px 0",
    color: "white",
    textAlign: "center",
  },
  headerTitle: {
    margin: 0,
    fontSize: "28px",
  },
  footer: {
    backgroundColor: "#333",
    color: "white",
    textAlign: "center",
    padding: "10px 0",
    marginTop: "auto",
  },
  footerText: {
    margin: 0,
    fontSize: "14px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formGroup: {
    marginBottom: "20px",
    position: "relative",
  },
  label: {
    fontSize: "14px",
    color: "#ffffff",
    marginBottom: "5px",
    fontWeight: "normal",
  },
  input: {
    width: "100%",
    borderRadius: "8px",
    fontSize: "16px",
    boxSizing: "border-box",
    transition: "border-color 0.3s ease",
    height: "calc(2.5rem + 0px)",
    padding: "0rem -0.25rem",
    backgroundColor: "none !important",
    border: "1px solid #52788e",
    color: "#ffffff",
  },
  textarea: {
    width: "100%",
    padding: "12px 15px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "16px",
    minHeight: "120px",
    transition: "border-color 0.3s ease",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
  },
  submitButton: {
    backgroundColor: "#071c40",
    color: "#fff",
    padding: "12px 30px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s ease",
  },
  submitButtonDisabled: {
    backgroundColor: "#ddd",
    cursor: "not-allowed",
  },
  alertContainer: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "9999",
  },
  alertBox: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    maxWidth: "400px",
    width: "100%",
  },
  alertMessage: {
    fontSize: "16px",
    marginBottom: "20px",
  },
  closeButton: {
    backgroundColor: "#071c40",
    color: "#fff",
    padding: "12px 30px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
};

export default CVUploadForm;
